// removed by extract-text-webpack-plugin
module.exports = {"clientReport":"iHPpvH8QXA7tPba1xUqbL","header":"_2NG30sooCqAzgT9BDm6Unv","footer":"_3Km9leM44lY5D2rBgYsZuE","headerRT":"x_b01uJOaPq_UbYjqjxFN","printIcon":"_2qi-dNFl8ne10uKU_WMmlP","closeIcon":"_37sP0W68Y8Y48Qe4ifHH_-","body":"_3lZjWP4kxZZMpD528ENq6I","headline":"_3FKHr3qYqzIi2ch0M9hhIM","subhead":"_2TaFqcfSdHeKfTkuQLhvif","copy":"_164g2sOa2N2PkEUvJvPZVq","subcopy":"_1LLPRD69OvsphS9Exl_yHp","downloadFPButton":"_2--qCaA-VhmXJf7uW62xlj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/ClientReport.css
// module id = 812
// module chunks = 0